import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
  SelfOnboardingActor,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.actor}selfonboarding/actor`;

export default async function upsertDefaultActorCommand(
  payload: SelfOnboardingActor,
): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    return await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: payload,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
